import { useState, useEffect, useCallback, useRef } from 'react';
import { IdentityService } from '../fetcher/IdentityService.js';

export const DOCUMENT_TAB_VIEW_SINGLE = 'single';
export const DOCUMENT_TAB_VIEW_CODES = 'codes';
export const DOCUMENT_TAB_VIEW_ALL = 'all';

const TAB_VIEW_MODES = new Set([
  DOCUMENT_TAB_VIEW_SINGLE,
  DOCUMENT_TAB_VIEW_CODES,
  DOCUMENT_TAB_VIEW_ALL,
]);

const SETTINGS_KEY = 'documentTabViewMode';

export const useDocumentTabViewSettings = () => {
  const [tabViewMode, setTabViewModeState] = useState(DOCUMENT_TAB_VIEW_SINGLE);
  const [isLoading, setIsLoading] = useState(true);

  const identityServiceRef = useRef(null);
  if (!identityServiceRef.current) {
    identityServiceRef.current = new IdentityService();
  }

  useEffect(() => {
    identityServiceRef.current.fetchUserSettings()
      .then(allSettings => {
        const saved = allSettings[SETTINGS_KEY];
        if (TAB_VIEW_MODES.has(saved)) {
          setTabViewModeState(saved);
        }
      })
      .catch(err => {
        console.error('Failed to fetch document tab view settings:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const setTabViewMode = useCallback((nextMode) => {
    if (!TAB_VIEW_MODES.has(nextMode)) {
      return;
    }
    setTabViewModeState(nextMode);
    identityServiceRef.current.updateUserSettings({
      [SETTINGS_KEY]: nextMode
    }).catch(err => {
      console.error('Failed to save document tab view settings:', err);
    });
  }, []);

  return {
    tabViewMode,
    setTabViewMode,
    isLoading,
  };
};
